import Layout from '@/layouts/Layout'
import i18n from '@/i18n'
import { UserRole } from '../enum'

export const constantRoutes = [
  {
    path: '/',
    name: 'home',
    redirect: '/enter-score',
    component: Layout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'intro',
        name: 'intro',
        component: () => import('@/views/dashboard/index'),
        meta: {
          title: i18n.t('route.dashboard'),
          requiresAuth: true,
          roles: [UserRole.Admin, UserRole.Manager, UserRole.Professor, UserRole.Student]
        }
      },
      {
        path: 'user',
        redirect: 'user/index',
        component: () => import('@/views/user/index'),
        children: [
          {
            path: 'index',
            name: 'user',
            component: () => import('@/views/user/components/ListUser'),
            meta: {
              title: i18n.t('route.user'),
              requiresAuth: true,
              roles: [UserRole.Admin]
            }
          }
        ]
      },
      {
        path: 'enter-score',
        redirect: 'enter-score/index',
        component: () => import('@/views/enter-score/index'),
        children: [
          {
            path: 'index',
            name: 'enter-score',
            component: () => import('@/views/enter-score/components/ListEnterScore'),
            meta: {
              title: i18n.t('route.enter_score'),
              requiresAuth: true,
              roles: [UserRole.Admin, UserRole.Manager, UserRole.Professor]
            }
          }
        ]
      },
      {
        path: 'import',
        redirect: 'import/index',
        component: () => import('@/views/import/index'),
        children: [
          {
            path: 'index',
            name: 'import',
            component: () => import('@/views/import/components/ListImport'),
            meta: {
              title: i18n.t('route.import'),
              requiresAuth: true,
              roles: [UserRole.Admin, UserRole.Manager]
            }
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/Login'),
    meta: {
      guest: true,
      title: i18n.t('route.login')
    }
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/dashboard/404'),
    meta: {
      title: i18n.t('route.not_found')
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js